"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipTypeCategory = exports.MembershipInsuranceOptionsMap = exports.MembershipCategoryEnum = void 0;
var MembershipCategoryEnum;
(function (MembershipCategoryEnum) {
    // Avdeling (hvist enabled), gruppe, sekundaer gruppe, instrument, forsikringring, kontingent (hvist enabled)
    MembershipCategoryEnum[MembershipCategoryEnum["MUSIKANT"] = 1] = "MUSIKANT";
    // Avdeling (hvist enabled), gruppe, sekundaer gruppe, instrument, forsikringring, kontingent (hvist enabled)
    MembershipCategoryEnum[MembershipCategoryEnum["ASPIRANT"] = 2] = "ASPIRANT";
    // Avdeling (hvist enabled), gruppe, sekundaer gruppe, instrument, forsikringring, kontingent (hvist enabled)
    MembershipCategoryEnum[MembershipCategoryEnum["DRILL"] = 3] = "DRILL";
    // forsikringring, kontingent (hvist enabled)
    MembershipCategoryEnum[MembershipCategoryEnum["STYRET_VERV"] = 4] = "STYRET_VERV";
    // subscriptions (array av feedpost tags, kan velge mellom alle grupper og avdelinger), kontingent (hvist enabled)
    MembershipCategoryEnum[MembershipCategoryEnum["DIRIGENT_INSTRUKTOER"] = 5] = "DIRIGENT_INSTRUKTOER";
    // Avdeling (hvist enabled), gruppe, sekundaer gruppe, instrument, forsikringring, kontingent (hvist enabled)
    MembershipCategoryEnum[MembershipCategoryEnum["DRILL_ASPIRANT"] = 6] = "DRILL_ASPIRANT";
    // forsikringring, kontingent (hvist enabled)
    MembershipCategoryEnum[MembershipCategoryEnum["IKKE_UTOEVENDE_NMF_MEDLEM"] = 7] = "IKKE_UTOEVENDE_NMF_MEDLEM";
    // forsikringring, kontingent (hvist enabled)
    MembershipCategoryEnum[MembershipCategoryEnum["IKKE_NMF_MEDLEM"] = 9] = "IKKE_NMF_MEDLEM";
})(MembershipCategoryEnum = exports.MembershipCategoryEnum || (exports.MembershipCategoryEnum = {}));
/**
 * Key = MembershipCategoryEnum
 *
 *
 * U = Uten instrument
 * M = Med instrument
 * I = Ingen forsikring
 */
exports.MembershipInsuranceOptionsMap = {
    [MembershipCategoryEnum.MUSIKANT]: ['M', 'U'],
    [MembershipCategoryEnum.ASPIRANT]: ['M', 'U'],
    [MembershipCategoryEnum.DRILL]: ['M', 'U'],
    [MembershipCategoryEnum.STYRET_VERV]: ['M', 'U', 'I'],
    [MembershipCategoryEnum.DIRIGENT_INSTRUKTOER]: ['M', 'U', 'I'],
    [MembershipCategoryEnum.DRILL_ASPIRANT]: ['M', 'U'],
    [MembershipCategoryEnum.IKKE_UTOEVENDE_NMF_MEDLEM]: ['M', 'U', 'I'],
    [MembershipCategoryEnum.IKKE_NMF_MEDLEM]: ['I'],
};
var MembershipTypeCategory;
(function (MembershipTypeCategory) {
    MembershipTypeCategory[MembershipTypeCategory["UNSET"] = 0] = "UNSET";
    // Hard set to 1 to make it as obvious as possible
    MembershipTypeCategory[MembershipTypeCategory["DEFAULT"] = 1] = "DEFAULT";
    // Set to 4 for compatibility with existing codebase (NMF-specific)
    MembershipTypeCategory[MembershipTypeCategory["ROLE_MEMBER"] = 4] = "ROLE_MEMBER";
    MembershipTypeCategory[MembershipTypeCategory["DIRIGENT_INSTRUKTOER"] = 5] = "DIRIGENT_INSTRUKTOER";
    MembershipTypeCategory[MembershipTypeCategory["AERESMEDLEM"] = 10] = "AERESMEDLEM";
    MembershipTypeCategory[MembershipTypeCategory["STOETTEMEDLEM"] = 11] = "STOETTEMEDLEM";
})(MembershipTypeCategory = exports.MembershipTypeCategory || (exports.MembershipTypeCategory = {}));
//# sourceMappingURL=membership.js.map